<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <blank-card :height="height">
    <span class="title block">{{ title }}</span>
    <span class="text-3xl pr-1 font-bold inline">{{ value }}</span>
    <span
      v-if="increase"
      class="text-xl text-green-600 font-bold inline"
    >
      <arrow-sm-up-icon class="h-6 w-5 inline" />{{ increase }}
    </span>
    <span
      v-if="decrease"
      class="text-xl text-red-600 font-bold inline"
    >
      <arrow-sm-down-icon class="h-6 w-5 inline" />{{ decrease }}
    </span>
  </blank-card>
</template>

<script>
import BlankCard from '@/Components/Cards/BlankCard'
import DownArrow from '@/Components/Icons/DownArrow'
import { ArrowSmUpIcon } from '@heroicons/vue/solid'
import { ArrowSmDownIcon } from '@heroicons/vue/solid'

export default {
  props: {
    title: {
      type: String,
      default: '# Products Stored'
    },
    value: {
      type: String,
      default: 120
    },
    increase: {
      type: String,
      default: ''
    },
    decrease: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: null
    }
  },
  components: { BlankCard, ArrowSmUpIcon, ArrowSmDownIcon },
  setup() {
    return {}
  }
}
</script>
